import {
  Yup,
  TRANSLATION,
} from "@/imports-files/components/model/custom-company-integration-modal.js";

const DomainMatch =
  /^(http|https):\/\/|[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,6}(:[0-9]{1,5})?(\/.*)?$/gm;

  export function getLinkedInJobsModal(t) {
    return {
      heading: "Authentication",
      description: t("modal:input_modal:description"),
      radios: [
        {
          text: t("modal:input_modal:text:linkedin_basic"),
          defaultvalue: "true",
          id: "obtainCompanyId",
          checked: "true",
        },
        {
          text: t("modal:input_modal:text:linkedin_premium"),
          defaultvalue: "false",
          id: "obtainCompanyId",
          checked: "false",
        },
      ],
      inputs: [
        {
          label: t("modal:input_modal:input:lable:company_id"),
          name: "company_id",
          placeholder: t("modal:input_modal:placeholder:company_id"),
          description: "obtainCompanyId",
        },
        {
          label: t("modal:input_modal:input:lable:contract_id"),
          name: "contract_id",
          placeholder: t("modal:input_modal:placeholder:contract_id"),
          description: "obtainContractId",
        },
      ],
    };
  }

export function getindeedModal(t) {
  return {
    heading: "Authentication",
    description: t("modal:input_modal:description"),

    inputs: [
      {
        label: t("modal:input_modal:input:lable:company_name"),
        tooltip: t("modal:input_modal:tooltip:company_name"),
        name: "company_name",
        placeholder: t("modal:input_modal:placeholder:company_name"),
      },
      {
        label: t("modal:input_modal:input:lable:campaign_tag"),
        tooltip: t("modal:input_modal:tooltip:campaign_tag"),
        name: "campaign_tag",
        placeholder: t("modal:input_modal:placeholder:campaign_tag"),
      },
    ],
  }
 }

 export function getTotalJobsModal(t) {
  return{
    heading: "Authentication",
    description: t("modal:input_modal:descriptionTotalJob"),

    inputs: [
      {
        label: t("modal:input_modal:input:lable:total_job_username"),
        name: "user_name",
        type: "text",
        placeholder: t("modal:input_modal:placeholder:total_job_username"),
        tooltip: t("modal:input_modal:tooltip:totaljob_username"),
      },
      {
        label: t("modal:input_modal:input:lable:password"),
        name: "password",
        type: "password",
        placeholder: t("modal:input_modal:placeholder:password"),
        tooltip: t("modal:input_modal:tooltip:totaljob_password"),
      },
    ],

  }
 }

export const CONSTANTS = {
  formInitialValues: {
    custom_integration: {
      name: "",
      domain: "",
      category: "",
    },
  },
  formValidations: Yup.object({
    custom_integration: Yup.object({
      name: Yup.string()
        .required(TRANSLATION("common:errors:required"))
        .nullable(true),
      domain: Yup.string()
        .required(TRANSLATION("common:errors:required"))
        .matches(DomainMatch, "Please enter correct domain"),
      category: Yup.string().required(TRANSLATION("common:errors:required")),
    }),
  }),

  indeedModal: {
    heading: "Authentication",
    description: TRANSLATION("modal:input_modal:description"),

    inputs: [
      {
        label: TRANSLATION("modal:input_modal:input:lable:company_name"),
        tooltip: TRANSLATION("modal:input_modal:tooltip:company_name"),
        name: "company_name",
        type: "text",
        placeholder: TRANSLATION("modal:input_modal:placeholder:company_name"),
      },
      {
        label: TRANSLATION("modal:input_modal:input:lable:campaign_tag"),
        tooltip: TRANSLATION("modal:input_modal:tooltip:campaign_tag"),
        name: "campaign_tag",
        type: "text",
        placeholder: TRANSLATION("modal:input_modal:placeholder:campaign_tag"),
      },
    ],

  },

  linkedInJobsModal: {
    heading: "Authentication",
    description: TRANSLATION("modal:input_modal:description"),
    radios: [
      {
        text: TRANSLATION("modal:input_modal:text:linkedin_basic"),
        defaultvalue: "true",
        id: "obtainCompanyId",
        checked: "true",
      },

      {
        text: TRANSLATION("modal:input_modal:text:linkedin_premium"),
        defaultvalue: "false",
        id: "obtainCompanyId",
        checked: "false",
      },
    ],
    inputs: [
      {
        label: TRANSLATION("modal:input_modal:input:lable:company_id"),
        name: "company_id",
        placeholder: TRANSLATION("modal:input_modal:placeholder:company_id"),
        type: "text",
        description:
          "To obtain your Company ID, please refer to the guide here for step-by-step instructions on how to access and view it.",
        description: "obtainCompanyId",
      },
      {
        label: TRANSLATION("modal:input_modal:input:lable:contract_id"),
        name: "contract_id",
        placeholder: TRANSLATION("modal:input_modal:placeholder:contract_id"),
        type: "text",
        description: "obtainContractId",
      },
    ],

  },
  totalJobsModal: {
    heading: "Authentication",
    description: TRANSLATION("modal:input_modal:descriptionTotalJob"),

    inputs: [
      {
        label: TRANSLATION("modal:input_modal:input:lable:total_job_username"),
        name: "user_name",
        type: "text",
        placeholder: TRANSLATION("modal:input_modal:placeholder:total_job_username"),
        tooltip: TRANSLATION("modal:input_modal:tooltip:totaljob_username"),
      },
      {
        label: TRANSLATION("modal:input_modal:input:lable:password"),
        name: "password",
        type: "password",
        placeholder: TRANSLATION("modal:input_modal:placeholder:password"),
        tooltip: TRANSLATION("modal:input_modal:tooltip:totaljob_password"),
      },
    ],
  },

  modalMap: {
    "CV-Library Paid": "cvLibraryPaid",
    "Indeed": "indeed",
    "LinkedIn Jobs": "linkedInJobs",
    "Total Jobs": "totalJobs",
  },
};

export function integrationValidationSchema(
  isAccountConnected,
  connectModal,
  selectedRadio
) {
  if (connectModal === "indeed") {
    return Yup.object({
      company_name: Yup.string()
        .required(TRANSLATION("errors:company_name_is_required"))
        .nullable(true),
    });
  }
  if (selectedRadio === "false") {
    return Yup.object({
      company_id: Yup.string().required(TRANSLATION("errors:company_id_is_required")).nullable(),
      contract_id: Yup.string()
        .required(TRANSLATION("errors:contract_id_is_required"))
        .when([], {
          is: () => isAccountConnected,
          then: Yup.string().required(TRANSLATION("errors:contract_id_is_required")).nullable(),
          otherwise: Yup.string().nullable(),
        }),
    });
  }
  if (connectModal === "totalJobs") {
    return Yup.object({
      user_name: Yup.string().required(TRANSLATION("errors:totaljob_username_required")).nullable(true),
      password: Yup.string().required(TRANSLATION("errors:password_is_required")).nullable(true),
    });
  }
  return Yup.object({
    company_id: Yup.string().required(TRANSLATION("errors:company_id_is_required")).nullable(),
  });
}
export function customCompnayIntegrationValidation() {
  let a = {
    custom_integration: Yup.object({
      name: Yup.string()
        .required(TRANSLATION("errors:required"))
        .nullable(true),
      domain: Yup.string()
        .required(TRANSLATION("errors:required"))
        .matches(DomainMatch, TRANSLATION("errors:invalid_domain")),
      category: Yup.string().required(TRANSLATION("errors:required")),
    }),
  };
  const CUSTOM_COMPANY_INTEGRATION_VALIDATION = Yup.object(a);
  return CUSTOM_COMPANY_INTEGRATION_VALIDATION;
}
